import styled from "styled-components/macro";

export const StyledCardButton = styled.button`
  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
  width: 100%;

  background: ${(props) => (props.disabled ? "#939DD6" : "#6270c6")};
  border: 1px solid #939dd6;
  border-radius: 4px;
  padding: 16px 0;

  text-transform: uppercase;
  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
  text-align: center;

  color: #fcfcfd;
`;